import 'whatwg-fetch';

const contentTypes = {
	json: 'application/json'
};

const parseErrorResponse = async (response) => {
	const text = response.text();
	return text ? JSON.parse(text) : {};
};

const parseJSON = response => (
	response.json()
);

const checkStatus = (response) => {
	if (response.status >= 200 && response.status < 300) {
		return response;
	}

	return parseErrorResponse(response).then((text) => {
		if (text.ok) {
			return text;
		}
		const error = { message: `${response.status}: ${response.statusText}`, data: text };
		throw error;
	});
}

const request = async (url, options) => (
	await fetch(url, options).then(checkStatus).then(parseJSON)
)

const getPayloadParams = (object = {}) => ({
	headers: { 'Content-Type': contentTypes.json },
	body: JSON.stringify(object)
});

export const sendData = async (rootUrl, url, object, { params: { method = 'POST' } = {} } = {}) => {
	const sendParams = getPayloadParams(object);
	const result =  await request(`${rootUrl}/${url}`, { ...sendParams, method });
	return result
};

export default { sendData };



// WEBPACK FOOTER //
// ./src/services/DB/index.js